import { SuccessRO } from '@routellers/types/dist/shared/success.ro';

import { ApiMethodDeclaration } from '..';

type ParamsData = undefined;

type ResponseData = SuccessRO;

export const generateJson: ApiMethodDeclaration<ParamsData, ResponseData> = () => ({
    url: '/translations/generate-json',
    method: 'GET',
});
